import React, { useState } from 'react';
import { Form, Input, Button, notification } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { login } from './../services/authService';

import "../components/Login.css"

function Login(){
    const [loading, setLoading] = useState(false);

    const handleLogin = async ({ username, password}) => {
        setLoading(true);

        try {
            await login(username, password);
            window.location = "/gralta";
        } catch (error) {
            notification["error"]({
                message: "Credenciales",
                description: "Usuario o contraseña incorrectas."
            });
            setLoading(false);
        }
    };

    return(<React.Fragment>
        <img className="logo" alt="logo" src="./assets/images/Logo.jpg" />
        <Form className="login-form" onFinish={handleLogin}>
            <Form.Item
                name="username"
                rules={[{ required: true, message: 'Escribe tu usuario!' }]}
            >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Usuario" />
            </Form.Item>
            <Form.Item
                name="password"
                rules={[{ required: true, message: 'Escribe tu contraseña!' }]}
            >
                <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Contraseña"
                />
            </Form.Item>
            <Form.Item >
                <Button className="btn-submit" loading={loading} htmlType="submit" size="large" block>
                Entrar
                </Button>
            </Form.Item>
        </Form>
    </React.Fragment>);
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js